// extracted by mini-css-extract-plugin
module.exports = {"container":"Beers_container__3F5qB","heading":"Beers_heading__2bEif","caption":"Beers_caption__23tko","captionCopy":"Beers_captionCopy__1U0eX","beers":"Beers_beers__3zwXy"};